import { Modal, Slider, Spin, Typography } from "antd";
import Title from "antd/es/typography/Title";
import React, { useEffect, useState } from "react";
import { RankingAPI } from "../../API/RankingAPI";
import { MoneyFormat } from "../MoneyFormat";
import {
  COST_SAVINGS_INITIAL_OBJECT,
  COST_SAVINGS_MARKS,
  COST_SAVINGS_STYLES,
} from "../../screens/Rankings/RankingsUtils";
import { useFlightModel } from "../../contexts/FlightModelContext";
const { Text } = Typography;

export default function CostSavings({
  open,
  setOpen,
  selectedRow,
  messageToast,
}) {
  const [inputElements, setInputElements] = useState(
    COST_SAVINGS_INITIAL_OBJECT,
  );
  const { selectedFlightModel, refreshFlightModels } = useFlightModel();
  const [spinning, setSpinning] = useState(false);

  function backFun() {
    setOpen(false);
    setInputElements(COST_SAVINGS_INITIAL_OBJECT);
  }

  async function sliderOnchange(newvalue) {
    setInputElements((prev) => ({
      ...prev,
      sliderValue: newvalue,
    }));
          let flightModelToUse = selectedFlightModel;

    // Fallback: fetch from context if not available
    if (!flightModelToUse) {
      const refreshed =await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }
    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
    const bodyData = {
      flight_model:flightModelToUse,
      //  localStorage.getItem("flight_model"),
      current_cost: selectedRow?.total_labor_cost_max,
      // "repeat_value": selectedRow?.repeat_max ? selectedRow?.repeat_max : selectedRow?.initial_max,
      repeat_max: selectedRow?.repeat_max,
      initial_max: selectedRow?.initial_max,
      repeat_type: selectedRow?.interval_type,
      labor_hrs: selectedRow?.total_effort_hours,
      raised_percent: newvalue,
      yield_percent: inputElements.yieldValue,
    };
    setSpinning(true);
    await RankingAPI.projectedCostSaving(bodyData)
      .then((res) => {
        if (res.data.status === true) {
          setInputElements((prev) => ({
            ...prev,
            projectCost: res.data?.data?.projected_savings,
            escalated_lab_ost: res.data?.data?.escalated_labor_cost,
            esculated_repeat_val: res.data?.data?.esclated_threshold_value,
            expectedSavings: res.data?.data?.expected_savings,
            threshold_type: res.data?.data?.threshold_type,
          }));
        } else {
          messageToast("error", res.data?.message);
        }
      })
      .catch((err) => {
        messageToast("error", "Internal Server Error");
      })
      .finally(() => setSpinning(false));
  }

  async function sliderYieldOnchange(newvalue) {
    setInputElements((prev) => ({
      ...prev,
      yieldValue: newvalue,
    }));
          let flightModelToUse = selectedFlightModel;

    // Fallback: fetch from context if not available
    if (!flightModelToUse) {
      const refreshed =await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }
    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
    const bodyData = {
      flight_model:flightModelToUse,
      //  localStorage.getItem("flight_model"),
      current_cost: selectedRow?.total_labor_cost_max,
      // "repeat_value": selectedRow?.repeat_max ? selectedRow?.repeat_max : selectedRow?.initial_max,
      repeat_max: selectedRow?.repeat_max,
      initial_max: selectedRow?.initial_max,
      repeat_type: selectedRow?.interval_type,
      labor_hrs: selectedRow?.total_effort_hours,
      raised_percent: inputElements.sliderValue,
      yield_percent: newvalue,
    };
    setSpinning(true);
    await RankingAPI.projectedCostSaving(bodyData)
      .then((res) => {
        if (res.data.status === true) {
          setInputElements((prev) => ({
            ...prev,
            projectCost: res.data?.data?.projected_savings,
            escalated_lab_ost: res.data?.data?.escalated_labor_cost,
            esculated_repeat_val: res.data?.data?.esclated_threshold_value,
            expectedSavings: res.data?.data?.expected_savings,
            threshold_type: res.data?.data?.threshold_type,
          }));
        } else {
          messageToast("error", res.data?.message);
        }
      })
      .catch((err) => {
        messageToast("error", "Internal Server Error");
      })
      .finally(() => setSpinning(false));
  }
  useEffect(() => {
    if (open && selectedRow) {
      setInputElements((prev) => ({
        ...prev,
        yieldValue: selectedRow?.yield_percentage * 100 ?? 0,
      }));
    }
  }, [open, selectedRow]);

  return (
    <Modal
      open={open}
      okText=""
      cancelText=""
      onCancel={() => backFun()}
      footer={[]}
    >
      <div style={{ padding: "10px" }}>
        <div
          style={{ marginBottom: "20px", borderBottom: "solid 1px #80808047" }}
        >
          <Title level={5}>
            Projected Cost Savings of{" "}
            <span style={{ color: "#304CB2" }}>{selectedRow?.spec}</span>
          </Title>
        </div>
        <Spin spinning={spinning}>
          <div>
            <div className="excalation_slider">
              <label style={{ display: "block", marginBottom: "-10px" }}>
                Escalation
              </label>
              <Slider
                step={null}
                value={inputElements.sliderValue}
                marks={COST_SAVINGS_MARKS}
                min={0}
                max={100}
                onChange={(e) => sliderOnchange(e)}
                onChangeComplete={(e) => sliderOnchange(e)}
              />
            </div>
            <div style={{ marginTop: "40px" }} className="yield_slider">
              <label style={{ display: "block", marginBottom: "-10px" }}>
                Yield
              </label>
              <Slider
                value={inputElements.yieldValue}
                marks={COST_SAVINGS_MARKS}
                min={0}
                max={100}
                onChange={(e) => {
                  setInputElements((prev) => ({
                    ...prev,
                    yieldValue: e,
                  }));
                }}
                onChangeComplete={(e) => sliderYieldOnchange(e)}
              />
            </div>
            <div
              style={{
                display: "flex",
                marginBottom: "15px",
                marginTop: "50px",
              }}
            >
              <div style={{ marginRight: "10px", flex: 1 }}>
                <label>Current Repeat Value</label>
                <div style={{ ...COST_SAVINGS_STYLES.blueBox }}>
                  {selectedRow?.repeat_max
                    ? selectedRow?.repeat_max
                    : selectedRow?.initial_max}
                </div>
              </div>
              <div style={{ marginLeft: "10px", flex: 1 }}>
                <label>Escalated Repeat Value</label>
                <div style={{ ...COST_SAVINGS_STYLES.blueBox }}>
                  {/* {inputElements.esculated_repeat_val} {inputElements.esculated_repeat_val !== "" && `- ${selectedRow?.interval_type}`} */}
                  {inputElements.esculated_repeat_val}{" "}
                  {inputElements.esculated_repeat_val !== "" &&
                    `- ${inputElements.threshold_type}`}
                </div>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ marginRight: "10px", flex: 1 }}>
                <label>Current Labor Cost</label>
                <div style={{ ...COST_SAVINGS_STYLES.blueBox }}>
                  {selectedRow?.total_labor_cost_max !== "" &&
                    `$ ${MoneyFormat(selectedRow?.total_labor_cost_max)}`}
                </div>
              </div>
              <div style={{ marginLeft: "10px", flex: 1 }}>
                <label>Escalated Labor Cost</label>
                <div style={{ ...COST_SAVINGS_STYLES.blueBox }}>
                  {inputElements.escalated_lab_ost !== "" &&
                    `$ ${MoneyFormat(inputElements.escalated_lab_ost)}`}
                </div>
              </div>
            </div>

            <div
              style={{
                ...COST_SAVINGS_STYLES.amountBox,
                backgroundColor: "rgba(38, 171, 164, 0.1)",
                border: "1px solid #26ABA4",
              }}
            >
              <Text style={{ color: "#26ABA4" }}>Projected Cost Savings</Text>
              <Text strong style={{ color: "#26ABA4" }}>
                $ {MoneyFormat(inputElements?.projectCost)}
              </Text>
            </div>
            <div
              style={{
                ...COST_SAVINGS_STYLES.amountBox,
                backgroundColor: "#ff78750f",
                border: "1px solid #ff7875",
              }}
            >
              <Text style={{ color: "#ff7875" }}>Expected Cost Savings</Text>
              <Text strong style={{ color: "#ff7875" }}>
                {" "}
                {typeof inputElements.expectedSavings === "number"
                  ? `$ ${MoneyFormat(inputElements?.expectedSavings)}`
                  : inputElements?.expectedSavings}
              </Text>
            </div>
          </div>
        </Spin>
      </div>
    </Modal>
  );
}
